module.exports = "<aside class=\"al-sidebar\" sidebarResize>\r\n    <ba-menu [menuHeight]=\"menuHeight\" [sidebarCollapsed]=\"isMenuCollapsed\" (expandMenu)=\"menuExpand()\"></ba-menu>\r\n</aside>"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baSidebar/baSidebar.html
// module id = 1588
// module chunks = 18